import { MarkerDataModel } from '@/models/marker/marker';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'ecpa-info',
})

export default class ECPAInfoComponent extends Vue {

    // --------------------------------------------------------
    // Properties

    @Prop()
    private showcaseData!: MarkerDataModel;

    private get ecpaRules() {
        const { context } = this.showcaseData;
        return context.ecpaRules;
    }

    private publisherList: any = [
        {
            name: 'Rule 1',
            key: 'R01',
        },
        {
            name: 'Rule 2',
            key: 'R02',
        },
        {
            name: 'Rule 3',
            key: 'R03',
        },
    ];

    // --------------------------------------------------------
    // Hooks

    // --------------------------------------------------------
    // Actions

    private onSelectPublisher(publisher: any) {
        publisher.isActive = !publisher.isActive;
        const { context } = this.showcaseData;
        if (context.ecpaRules.indexOf(publisher.key) !== -1) {
            context.ecpaRules = context.ecpaRules.filter((item: any) => item !== publisher.key);
        } else {
            context.ecpaRules.push(publisher.key);
        }
    }

}
